<template>
  <div class="order">
    <OrderDetailHeader title="确认订单"></OrderDetailHeader>
    <div class="order-detail">
      <div class="card">
        <div class="info">
          <div class="info-header">
            <span class="info-title">订单类型：</span>
            <span class="info-value">挂牌</span>
          </div>
        </div>
      </div>
      <!-- 买家，卖家信息 -->
      <OrderInfoCard :userInfo="userInfo" :listingDetail="listingDetail"></OrderInfoCard>
      <!-- 产品信息 -->
      <OrderCommodityCard
        :listingDetail="listingDetail"
        :stations="stationsStr"
        :orderWeight="orderWeight"
        :sumMoney="sumMoney"
      ></OrderCommodityCard>
      <!-- 交付方式 -->
      <OrderDeliveryCard :listingDetail="listingDetail"></OrderDeliveryCard>
      <OrderPayCard></OrderPayCard>
      <OrderDeliveryTypeCard></OrderDeliveryTypeCard>
      <!-- <OrderInvoiceCard></OrderInvoiceCard> -->
      <div class="card remark">
        <div class="info">
          <div class="info-header">备注</div>
          <van-field
            v-model="remark"
            type="textarea"
            rows="3"
            maxlength="50"
            placeholder="请输入"
            border
          ></van-field>
        </div>
      </div>
      <div class="agreement">
        <van-checkbox v-model="agree" shape="square" checked-color="#E12020">接受协议</van-checkbox>
        <div>
          <span class="link" @click="viewAgreement('06','XY200527134126765')">查看交易协议</span>
          <span
            v-if="listingDetail.materialCode == PNGmaterialCode"
            class="link"
            style="margin-left:10px"
            @click="viewAgreement('06','XY200527114319762')"
          >查看订单协议</span>
        </div>
      </div>
      <div class="bottom-btn">
        <span>合计：</span>
        <div class="total-amount">{{sumMoney}}</div>
        <van-button class="submit-btn" @click="submitOrder">确认提交</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import OrderDetailHeader from "./components/Header.vue";
import OrderInfoCard from "./components/OrderInfoCard";
import OrderCommodityCard from "./components/OrderCommodityCard";
import OrderDeliveryCard from "./components/OrderDeliveryCard";
import OrderPayCard from "./components/OrderPayCard";
import OrderDeliveryTypeCard from "./components/OrderDeliveryTypeCard";
// import OrderInvoiceCard from "./components/OrderInvoiceCard";
import listApi from "@/request/listApi";
import goodsApi from "@/request/goodsApi";
export default {
  name: "SubmitOrder",
  components: {
    OrderDetailHeader,
    OrderInfoCard,
    OrderCommodityCard,
    OrderDeliveryCard, //交收期限
    OrderPayCard, //支付方式
    OrderDeliveryTypeCard, //交货方式
    // OrderInvoiceCard,//开票信息
  },
  props: {
    id: String,
    purchaseVolume: String,
    stations: String,
  },
  data() {
    return {
      orderStatus: "0",
      LNGmaterialCode: this.$common.interfacePath.LngMaterialCode,
      PNGmaterialCode: this.$common.interfacePath.PngMaterialCode,
      listingDetail: {},
      commodityDetail: {},
      sumMoney: "",
      agree: false,
      deliveryMode: "",
      remark: "",
      agreementData: [],
      agreementList: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    orderWeight() {
      return Number(this.purchaseVolume);
    },
    stationArr() {
      return JSON.parse(this.stations);
    },
    stationsStr() {
      if (!this.stationArr || this.stationArr.length == 0) {
        return "";
      }
      if (this.stationArr.length == 1) {
        return this.stationArr[0].stationName;
      }
      let str;
      for (let i = 0; i < this.stationArr.length; i++) {
        if (i == 0) {
          str += this.stationArr[i].stationName;
        } else {
          str += "," + this.stationArr[i].stationName;
        }
      }
      return str;
    },
  },
  mounted() {
    // eslint-disable-next-line no-debugger
    // debugger;
    console.log(this.id);
    console.log(this.orderWeight);
    console.log(this.stations);
    console.log(this.stationArr);
    console.log(this.stationsStr);
    this.getlistingDetail();
    this.getviewAgreement();
  },
  methods: {
    //获取挂牌信息
    getlistingDetail() {
      let params = {
        id: this.id,
      };
      listApi.listingDetail(params).then((res) => {
        if (res.returnCode == "0") {
          this.listingDetail = res.result;
          this.sumMoney = this.$utils.amount(
            this.listingDetail.price * this.orderWeight
          );
          this.getCommodityById(this.listingDetail.commodityId);
          this.listingDetail.deliveryDateStart = this.$utils.formatDate(
            this.listingDetail.deliveryDateStart
          );
          this.listingDetail.deliveryDateEnd = this.$utils.formatDate(
            this.listingDetail.deliveryDateEnd
          );
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    //获取产品信息
    getCommodityById(id) {
      let params = {
        id: id,
      };
      goodsApi.getCommodityById(params).then((res) => {
        if (res.returnCode == "0") {
          this.commodityDetail = res.result;
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    //查看协议
    viewAgreement(agreementType, templateId) {
      console.log(agreementType, templateId);
      this.$router.push({
        path: "/viewAgreement",
        query: {
          agreementType,
          templateId,
        },
      });
    },
    async getviewAgreement() {
      let params = {
        agreementType: "",
        templateId: "",
      };
      let res = await listApi.getAgreement(params);
      if (res.returnCode === "0") {
        this.agreementData = res.result.dataList;
        for (let i of this.agreementData) {
          let protocolInfo = {};
          protocolInfo.agreementId = i.agreementId;
          protocolInfo.agreementVer = i.agreementVer;
          protocolInfo.agreementType = i.agreementType;
          protocolInfo.agreementUrl = i.agreementUrl;
          protocolInfo.agreementName = i.agreementName;
          protocolInfo.templateId = i.templateId;
          this.agreementList.push(protocolInfo);
        }
      } else {
        this.$toast({
          type: "fail",
          message: res.returnMessage,
          duration: 1500,
        });
      }
    },
    //提交订单
    async submitOrder() {
      if (!this.stationArr) {
        this.$toast({
          type: "fail",
          message: "请选择场站",
          duration: 1500,
        });
        return;
      }
      if (!this.agree) {
        this.$toast({
          type: "fail",
          message: "请勾选协议",
          duration: 1500,
        });
        return;
      } else {
        if (this.listingDetail.commodityName == this.PNGmaterialCode) {
          this.deliveryMode = "3";
        }
        let params = {
          tradeId: this.$route.query.id, //挂牌ID
          quantity: this.orderWeight, //订单量
          payType: "1", //支付方式  1：ERP余额支付
          deliveryMode: this.deliveryMode, //提货方式（1：自提/2：配送 3、管输）
          payModel: "1", //付款方式 1：全额支付
          remark: this.remark, //备注
          orderAmount: this.sumMoney, //总金额
          pipelineName: this.listingDetail.pipelineName,
          staions: this.stationArr,
          // stationName: this.station,
          // stationCode: this.listingDetail.stations.find(
          //   (item) => item.stationName == this.station
          // ).stationCode,
          // stationAddress: this.listingDetail.stationAddress,
          protocolInfos: this.agreementList,
          deliveryDateStart: this.listingDetail.deliveryDateStart,
          deliveryDateEnd: this.listingDetail.deliveryDateEnd,
        };
        await listApi.createNgListOrder(params).then((res) => {
          if (res.returnCode == "0") {
            this.$dialog
              .alert({
                message: "挂牌订单提交成功！",
              })
              .then(() => {
                this.$router.push({
                  path: "/order",
                });
              });
          } else {
            this.$toast({
              type: "fail",
              message: res.returnMessage,
              duration: 1500,
            });
          }
        });
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.order {
  display: flex;
  flex-direction: column;
  height: 100%;

  .order-detail {
    flex: 1;
    overflow: auto;
  }
}

.order >>> .van-cell {
  font-size: 26px;
  line-height: 49px;
  border: 1px solid rgba(153, 153, 153, 1);
  border-radius: 10px;
}

.order-status {
  width: 100%;
  height: 88px;
  line-height: 88px;
  // vertical-align center
  padding: 0 40px;
  background: #ffffff;
  color: #E12020;
  font-size: 36px;
}

.card {
  // margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;
    }

    .submit-btn {
      margin-top: 24px;
      width: 702px;
      height: 80px;
      background: linear-gradient(132deg, rgba(239, 150, 35, 1) 0%, rgba(225, 32, 32, 1) 100%);
      opacity: 1;
      border-radius: 40px;
      font-size: 34px;
      color: #FFFFFF;
    }
  }
}

.remark {
  margin-top: 24px;
}

.agreement >>>.van-checkbox {
  .van-checkbox__icon {
    font-size: 26px;
    line-height: 37px;
  }

  .van-checkbox__label {
    height: 37px;
    font-size: 26px;
    font-weight: 400;
    line-height: 37px;
    color: rgba(225, 32, 32, 1);
    opacity: 1;
  }
}

.agreement {
  display: flex;
  height: 84px;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;

  // font-size: 26px;
  .link {
    height: 37px;
    font-size: 26px;
    font-weight: 400;
    line-height: 37px;
    color: rgba(58, 112, 204, 1);
    text-decoration: underline;
    opacity: 1;
  }
}

.bottom-btn {
  // width: 750px;
  height: 100px;
  padding: 0 24px;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  span {
    font-size: 26px;
    font-weight: 400;
    line-height: 37px;
  }

  .total-amount {
    // width: 253px;
    height: 62px;
    font-size: 44px;
    font-weight: 400;
    line-height: 62px;
    color: rgba(225, 32, 32, 1);
    opacity: 1;
  }

  .submit-btn {
    width: 200px;
    height: 72px;
    background: linear-gradient(132deg, rgba(239, 150, 35, 1) 0%, rgba(225, 32, 32, 1) 100%);
    opacity: 1;
    border-radius: 40px;
    font-size: 34px;
    color: #FFFFFF;
    margin-left: 20px;
  }
}
</style>